// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_a4e5c162","inner":"rdg_e9d36622"};